import i18n from '@/lib/language'
export default [
  {
    path: 'smart',
    name: 'smartForm',
    // component: () => import(`@/pc/smartForm/Index`),
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/smartForm/Index'),
    meta: { title: i18n.t('message["1244"]') }
  },
  {
    path: 'smart/intercept',
    name: 'smartIntercept',
    // component: () => import('@/pc/smartForm/intercept/Index'),
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/smartForm/intercept/Index'),
    meta: { title: i18n.t('message["584"]') }
  }
]
